// NOTE: Then general practice of manipulating the page HTML via javascript is not great.
// If possible, always try to make the appropriate changes in the appropriate place and not use
// JS as a hack even though it may be faster/easier.

/**
 * TODO: retire this.. we should be adding the attribute in the HTML appropriately
 * give all class="external" links the target = blank attribute
 */
export const openExternalLinksInNewTab = () => {
	$(".external").attr("target", "_blank");
}

/**
 * 	TODO: This should be retired in favor of native browser functionality - JTH 5/3/22
 * 	https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attr-loading
 */
export const postLoadImages = () => {
	$(".post-load").each(function(i, e) {
		const realSrc = $(e).attr("realsrc");
		if (realSrc !== "") {
			$(e).attr("src", realSrc);
			$(e).removeAttr("realSrc");
		}
	});
}